import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from 'react-loader-spinner';

interface IDownloadProductImage {
  loading: boolean;
  disabled?: boolean;
  onOpenDownload: () => void;
}

const DownloadProductImageCard: FC<IDownloadProductImage> = ({ loading, disabled = false, onOpenDownload }) => {
  const { t } = useTranslation();

  return (
    <div className="cto-downloadProdImagesCard">
      <h4 className="cto-downloadProdImagesCard__title">{t('DownloadProductImageCard:DownloadProductImages')}</h4>
      <h4 className="cto-downloadProdImagesCard__text">
        {t('DownloadProductImageCard:DownloadSelectedProductsImages')}
      </h4>
      <div className="cto-btn -createCatalog -brand-01 -downloadProductImages">
        <button className="cto-btn__element" type="button" disabled={loading || disabled} onClick={onOpenDownload}>
          {loading ? (
            <Loader type="ThreeDots" color="#fff" width={40} height={10} />
          ) : (
            <span className="cto-btn__text">{t('DownloadProductImageCard:DownloadImages')}</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default DownloadProductImageCard;
